import React from 'react';

const ICONA_STATO = {
  raccolta: { simbolo: '✓', classe: 'salab-voce--raccolta', label: 'Raccolta' },
  mancante: { simbolo: '○', classe: 'salab-voce--mancante', label: 'Mancante' },
  saltata: { simbolo: '–', classe: 'salab-voce--saltata', label: 'Saltata' },
};

// Valore raccolto in forma breve (può essere stringa, numero, lista, oggetto)
function valoreBreve(valore, max = 80) {
  if (valore === null || valore === undefined || valore === '') return '';
  let s;
  if (typeof valore === 'string') s = valore;
  else if (Array.isArray(valore)) s = valore.map((v) => (typeof v === 'string' ? v : JSON.stringify(v))).join(', ');
  else if (typeof valore === 'object') s = JSON.stringify(valore);
  else s = String(valore);
  return s.length > max ? `${s.slice(0, max - 1)}…` : s;
}

function valoreCompleto(valore) {
  if (valore === null || valore === undefined) return '';
  return typeof valore === 'string' ? valore : JSON.stringify(valore, null, 1);
}

function Barra({ valore, totale }) {
  const pct = totale > 0 ? Math.round((valore / totale) * 100) : 0;
  return (
    <div className="salab-barra" aria-hidden="true">
      <div className="salab-barra-fill" style={{ width: `${pct}%` }} />
    </div>
  );
}

export default function AvanzamentoPanel({ stato }) {
  if (!stato) {
    return (
      <div className="card salab-avanzamento">
        <h2 className="section-title salab-h2">Avanzamento</h2>
        <p className="salab-muted">Avvia una sessione per vedere le voci da raccogliere.</p>
      </div>
    );
  }

  const voci = Array.isArray(stato.voci) ? stato.voci : [];
  // Raggruppa per blocco mantenendo l'ordine di arrivo
  const blocchi = [];
  const indice = {};
  voci.forEach((v) => {
    const b = v.blocco || 'Senza blocco';
    if (!(b in indice)) {
      indice[b] = blocchi.length;
      blocchi.push({ nome: b, voci: [] });
    }
    blocchi[indice[b]].voci.push(v);
  });

  return (
    <div className="card salab-avanzamento">
      <h2 className="section-title salab-h2">Avanzamento</h2>

      <div className="salab-contatori">
        <div>
          <div className="salab-contatore-num">
            ★ {stato.stelle_raccolte ?? 0}/{stato.stelle_totali ?? 0}
          </div>
          <div className="salab-muted salab-xs">set minimo (prioritarie)</div>
          <Barra valore={stato.stelle_raccolte ?? 0} totale={stato.stelle_totali ?? 0} />
        </div>
        <div>
          <div className="salab-contatore-num">
            {stato.raccolte ?? 0}/{stato.totale ?? 0}
          </div>
          <div className="salab-muted salab-xs">voci raccolte</div>
          <Barra valore={stato.raccolte ?? 0} totale={stato.totale ?? 0} />
        </div>
      </div>

      {blocchi.map((b) => (
        <div key={b.nome} className="salab-blocco">
          <div className="salab-blocco-titolo">{b.nome}</div>
          <ul className="salab-voci">
            {b.voci.map((v) => {
              const icona = ICONA_STATO[v.stato] || ICONA_STATO.mancante;
              const breve = v.stato === 'raccolta' ? valoreBreve(v.valore) : '';
              return (
                <li
                  key={v.codice}
                  className={`salab-voce ${icona.classe}`}
                  title={[`${v.codice} · ${icona.label}`, v.testo, valoreCompleto(v.valore)].filter(Boolean).join('\n')}
                >
                  <span className="salab-voce-icona" aria-label={icona.label}>{icona.simbolo}</span>
                  <span className="salab-voce-corpo">
                    <span className="salab-voce-testo">
                      {v.stella && <span className="salab-stella" aria-label="prioritaria">★ </span>}
                      <span className="salab-voce-codice">{v.codice}</span> {v.testo}
                    </span>
                    {breve && <span className="salab-voce-valore">{breve}</span>}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
}
